import $ from 'jquery';

const scrollTo = (number) => {
	if (!$(`.storybg.-story${number}`).hasClass('-show')) {
		$('.storybg').removeClass('-show');
		$(`.storybg.-story${number}`).addClass('-show');
	}
};

export default scrollTo;



// WEBPACK FOOTER //
// ./src/js/about/scrollTo.js